var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 96 96" },
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        version: "1.1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 96 96",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", [
        _c("g", [
          _c("path", {
            attrs: {
              d: "M48,55.1c12.1,0,22-9.9,22-22s-9.9-22-22-22s-22,9.9-22,22S35.9,55.1,48,55.1z M48,15.1c9.9,0,18,8.1,18,18s-8.1,18-18,18    s-18-8.1-18-18S38.1,15.1,48,15.1z",
            },
          }),
          _c("path", {
            attrs: {
              d: "M8.1,84.9c1.1,0,2-0.9,2-2c0-11.6,8.4-21.5,19.7-23.4c5.3,3.7,11.6,5.6,18.1,5.6s12.8-2,18.1-5.6    c11.3,1.9,19.7,11.9,19.7,23.4c0,1.1,0.9,2,2,2s2-0.9,2-2c0-13.8-10.3-25.6-24-27.5c-0.5-0.1-1,0.1-1.5,0.4    C59.7,59.2,54,61.1,48,61.1s-11.7-1.9-16.4-5.4c-0.4-0.3-0.9-0.4-1.5-0.4c-13.7,1.9-24,13.7-24,27.5C6.1,84,7,84.9,8.1,84.9z",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }